import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function Vans() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    MNVVanID: 0,
    MNVVanTypeID: 0,
    MNVBaseID: 0,
    MNVMoverID: "",
    Name: "",
    RegistrationNo: "",
  });
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
        "api/MNVVan/MNVVanGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL + "api/MNVVan/MNVVanGetCompleteGridData"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "MNVVanID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.MNVVanTypeID || addEditObject.MNVVanTypeID == 0) {
      showErrorMessage("Please select Van Type");
      IsOkay = false;
    } else if (
      !addEditObject.MNVBaseID ||
      addEditObject.MNVBaseID == 0
    ) {
       showErrorMessage("Please select Base");
      IsOkay = false;
    } else if (!addEditObject.Name || addEditObject.Name == "") {
       showErrorMessage("Please select Name");
      IsOkay = false;
    } else if (!addEditObject.RegistrationNo || addEditObject.RegistrationNo == "") {
       showErrorMessage("Please select Registration No");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVVanID = addEditObject.MNVVanID;
    object.MNVVanTypeID = addEditObject.MNVVanTypeID;
    object.MNVBaseID = addEditObject.MNVBaseID;
    object.MNVMoverID = addEditObject.MNVMoverID;
    object.Name = addEditObject.Name;
    object.RegistrationNo = addEditObject.RegistrationNo;
    object.IsActive = addEditObject.IsActive;
    object.CreatedByName = addEditObject.CreatedByName;
    object.CreatedByUserName = addEditObject.CreatedByUserName;
    object.CreationTimestamp =
      addEditObject.CreationTimestamp;
    object.LastUpdatedByUserName = addEditObject.LastUpdatedByUserName;
    object.LastUpdatedTimestamp = addEditObject.LastUpdatedTimestamp;
    object.IsDeleted = addEditObject.IsDeleted;

    axiosAuth
      .post(AppContext.APIURL + "api/MNVVan/MNVVanSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message)
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVVanID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVVan/MNVVanDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVVanTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVVanTypeName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVBaseName")) {
        (
          document.getElementById(
            "imgSort" + "MNVBaseName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MNVVanID: 0,
                      MNVVanTypeID: 0,
                      MNVBaseID: 0,
                      MNVMoverID: "",
                      Name: "",
                      RegistrationNo: "",
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblvans", "vans")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>

          <table className="reuse-table" id="tblvans">
            <thead>
              <tr>
                <th>
                  <div className="flex-d flex-ac flex-jc flex-gap20">
                    <div className="flex-d flex-ac flex-gap5">
                      Van Type
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "MNVVanTypeName")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("MNVVanTypeName")}
                        title={"Sort By Mover Type"}
                      >
                        <span id={"imgSort" + "MNVVanTypeName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-d flex-ac flex-jc flex-gap20">
                    <div className="flex-d flex-ac flex-gap5">
                      Base
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "MNVBaseName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("MNVBaseName")
                        }
                        title={"Sort By Base"}
                      >
                        <span id={"imgSort" + "MNVBaseName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-d flex-ac flex-jc flex-gap20">
                    <div className="flex-d flex-ac flex-gap5">
                      Mover
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "MNVMoverName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("MNVMoverName")
                        }
                        title={"Sort By User"}
                      >
                        <span id={"imgSort" + "MNVMoverName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Name</th>
                <th>Registration No</th>
                <th>Is Active</th>
                {/* <th>Created By Name</th>
                <th>Created By Username</th>
                <th>Creation Time stamp</th>
                <th>Last Updated By Name</th>
                <th>Last Updated By Username</th>
                <th>Last Updated Time stamp</th>
                <th>Is Deleted</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td>{item.MNVVanTypeName}</td>
                        <td>{item.MNVBaseName}</td>
                        <td>{item.MNVMoverName}</td>
                        <td>{item.Name}</td>
                        <td>{item.RegistrationNo}</td>
                        <td>{item.IsActive == true ? "true" : "false"}</td>
                        {/* <td>{item.CreatedByName}</td>
                        <td>{item.CreatedByUserName}</td>
                        <td>{item.CreationTimestamp}</td>
                        <td>{item.LastUpdatedByName}</td>
                        <td>{item.LastUpdatedByUserName}</td>
                        <td>{item.LastUpdatedTimestamp}</td>
                        <td>{item.IsDeleted == true ? "true" : "false"}</td> */}
                        <td>
                          <div className="flex-daj gap-10">
                            <a
                              onClick={() => {
                                setIsAddNew(2);
                                setAddEditObject({
                                  MNVVanID: item.MNVVanID,
                                  MNVVanTypeID: item.MNVVanTypeID,
                                  MNVBaseID: item.MNVBaseID,
                                  MNVMoverID: item.MNVMoverID,
                                  Name: item.Name,
                                  RegistrationNo: item.RegistrationNo,
                                });
                              }}
                            >
                              <img
                                src="images/edit.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                            <a
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.MNVVanID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="18px"
                                height="18px"
                                alt="Delete"
                              />
                            </a>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Van Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVVanTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVVanTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select van</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Base:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVBaseID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVBaseID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Base</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Mover:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVMoverID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVMoverID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Mover</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Registration No:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.RegistrationNo}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      RegistrationNo: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Vans;
